import axios from '@/plugins/axios';

const baseUrl = '/api/annotations';

export const fetchAnnotations = async (datasetId) => {
  const response = await axios.get(`${baseUrl}?dataset_id=${datasetId}`);
  return response.data;
};

export const fetchAnnotation = async (datasetId, version, taskId, llmId) => {
  const response = await axios.get(
    `${baseUrl}/${datasetId}/${version}/${taskId}/${llmId}`
  );
  return response.data;
};

export const createAnnotation = async (payload) => {
  const response = await axios.post(baseUrl, payload);
  return response.data;
};

export const updateAnnotation = async (id, payload) => {
  const response = await axios.post(`${baseUrl}/${id}/update`, payload);
  return response.data;
};

export const deleteAnnotation = async (id) => {
  const response = await axios.post(`${baseUrl}/${id}/delete`);
  return response.data;
};
